import { noop } from 'lodash/fp';
import React from 'react';
import { useSelector } from 'react-redux';

import { ChangePassword, ConnectedResetPassword } from '@portals/framework';
import { getErrorByActionName } from '@portals/redux';

import Notification from '../../components/layout/Notification';
import { AuthWrapper } from './common';

export const ResetPassword = () => {
  const resetPasswordLinkError = useSelector(
    getErrorByActionName('resetPasswordLink')
  );

  return (
    <AuthWrapper>
      <ConnectedResetPassword />

      <Notification error={resetPasswordLinkError} onClear={noop} />
    </AuthWrapper>
  );
};

export const ChangePasswordPage = () => {
  const changePasswordTokenError = useSelector(
    getErrorByActionName('changePasswordToken')
  );

  return (
    <AuthWrapper>
      <ChangePassword />

      <Notification error={changePasswordTokenError} onClear={noop} />
    </AuthWrapper>
  );
};
